import React from 'react';
import '../styles/Common.css'; // 공통 스타일

const ProductReport = () => {
  return (
    <div className="common-container">
      <h1>생산 보고서</h1>
    </div>
  );
};

export default ProductReport;
